import GLU from '../glu2.js/src/index';

class ListingsApi extends GLU.Api {
    constructor(endpoint) {
        super(endpoint);

        this.createApiActions(
            {
                // Lean feed of facility ids the user can see as listed on the
                // platform — used to color facility pins "by listing status".
                name: 'mapFacilityIds',
                method: GLU.Api.Get,
                path: '/api/v1/listings/map-facility-ids',
                credentials: true,
            },
        );
    }
}

export default ListingsApi;
